module.exports = __webpack_public_path__ + "img/codelogo-zh.ab014225.png";